export default __webpack_public_path__ + "static/media/fileexcel.beed3d8d.svg";